export function checkInputUtility(expectedRaw, userRaw) {
  const cleanSelectedLetters = String(expectedRaw)
    .replace(/\s+/g, "")
    .toUpperCase();

  const cleanInput = String(userRaw)
    .replace(/\s+/g, "")
    .toUpperCase();

  let totalCharacters = cleanSelectedLetters.length;
  let correctCount = 0;
  let errorCount = 0;
  let highlightedText = [];
  let groupedText = [];

  const maxLength = Math.max(cleanInput.length, cleanSelectedLetters.length);

  for (let i = 0; i < maxLength; i++) {
    const userChar = cleanInput[i] || "_";
    const correctChar = cleanSelectedLetters[i] || "_";

    if (userChar === correctChar) {
      correctCount++;
      highlightedText.push(`<span class="correct">${userChar}</span>`);
    } else {
      errorCount++;
      highlightedText.push(`<span class="incorrect">${userChar}</span>`);
    }

    if ((i + 1) % 5 === 0) {
      groupedText.push(`<div class="group">${highlightedText.join("")}</div>`);
      highlightedText = [];
    }
  }

  if (highlightedText.length > 0) {
    groupedText.push(`<div class="group">${highlightedText.join("")}</div>`);
  }

  const calculatedAccuracy =
    totalCharacters > 0
      ? ((correctCount / totalCharacters) * 100).toFixed(2)
      : 0;

  return {
    calculatedAccuracy,
    groupedHTML: groupedText.join(" "),
    errorCount,
  };
}